import React from 'react';
import { Image, View } from 'react-native';

const ActiveTilePicture = React.memo(
  ({ url, C, scale }) => (
    <View style={{ width: '100%', height: '100%' }}>
      <View
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: C('Overlay/Light/Dim very light'),
          opacity: 0.5,
          position: 'absolute',
        }}
      />
      {url ? <Image source={{ uri: url }} style={{ width: '100%', height: '100%' }} resizeMode="contain" /> : null}
      <View
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: C('Overlay/Light/Dim light'),
          opacity: 0.5,
          borderRadius: scale(2),
          position: 'absolute',
        }}
      />
    </View>
  ),
  (prev, next) => prev?.C?.schemeName === next?.C?.schemeName && prev.url === next.url
);

export default ActiveTilePicture;
